module.exports = __webpack_public_path__ + "img/direction_left.5fe1fa64.jpg";